/* MT – interacciones de la tienda (vanilla, sin librerías) */
(function () {
  // Varias secciones cargan este archivo: solo se inicializa una vez
  if (window.__mtIniciado) return;
  window.__mtIniciado = true;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveal() {
    var els = document.querySelectorAll('.mt-reveal:not(.mt-visible)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('mt-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0, rootMargin: '0px 0px -30px 0px' });
    els.forEach(function (el) { io.observe(el); });
    // Respaldo: si el navegador no avisa a tiempo, se muestran al pasar por pantalla
    var pendiente = false;
    function revisar() {
      pendiente = false;
      document.querySelectorAll('.mt-reveal:not(.mt-visible)').forEach(function (el) {
        if (el.getBoundingClientRect().top < window.innerHeight) el.classList.add('mt-visible');
      });
    }
    window.addEventListener('scroll', function () {
      if (!pendiente) { pendiente = true; setTimeout(revisar, 120); }
    }, { passive: true });
    setTimeout(revisar, 400);
  }

  function initParallax() {
    var els = document.querySelectorAll('[data-mt-parallax]');
    if (!els.length || reduce || window.innerWidth < 990) return;
    var ticking = false;
    function update() {
      els.forEach(function (el) {
        var r = el.getBoundingClientRect();
        var k = parseFloat(el.getAttribute('data-mt-parallax')) || 0;
        var off = (r.top + r.height / 2 - window.innerHeight / 2) * -k / 100;
        el.style.transform = 'translate3d(0,' + off.toFixed(1) + 'px,0)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  function initProducto() {
    document.querySelectorAll('[data-mt-producto]').forEach(function (root) {
      var principal = root.querySelector('[data-mt-principal]');
      var minis = root.querySelectorAll('[data-mt-mini]');
      function mostrar(btn) {
        if (!btn || !principal) return;
        principal.style.opacity = 0;
        setTimeout(function () {
          principal.src = btn.getAttribute('data-src');
          principal.srcset = '';
          principal.alt = btn.getAttribute('data-alt') || '';
          principal.style.opacity = 1;
        }, 180);
        minis.forEach(function (m) { m.classList.toggle('is-activa', m === btn); });
      }
      minis.forEach(function (m) { m.addEventListener('click', function () { mostrar(m); }); });

      var cant = root.querySelector('[data-mt-cantidad]');
      if (cant) {
        var input = cant.querySelector('input');
        cant.querySelectorAll('button').forEach(function (b) {
          b.addEventListener('click', function () {
            var v = parseInt(input.value, 10) || 1;
            v += b.getAttribute('data-paso') === '+' ? 1 : -1;
            input.value = Math.max(1, v);
          });
        });
      }

      var datos = root.querySelector('[data-mt-variantes]');
      if (!datos) return;
      var variantes = JSON.parse(datos.textContent);
      var idInput = root.querySelector('input[name="id"]');
      var precio = root.querySelector('[data-mt-precio]');
      var tachado = root.querySelector('[data-mt-tachado]');
      var ahorro = root.querySelector('[data-mt-ahorro]');
      var boton = root.querySelector('[data-mt-boton]');
      var textoBoton = boton ? boton.getAttribute('data-texto') : '';
      var textoAgotado = boton ? boton.getAttribute('data-agotado') : '';

      root.querySelectorAll('[data-mt-opcion] input').forEach(function (r) {
        r.addEventListener('change', function () {
          var elegidas = [];
          root.querySelectorAll('[data-mt-opcion]').forEach(function (fs) {
            var c = fs.querySelector('input:checked');
            elegidas.push(c ? c.value : null);
          });
          var v = variantes.find(function (x) {
            return x.options.every(function (o, i) { return o === elegidas[i]; });
          });
          if (!v) {
            // Combinación que no existe: no dejar comprar otra variante por error
            if (boton) { boton.disabled = true; boton.querySelector('span').textContent = 'No disponible en esta combinación'; }
            return;
          }
          idInput.value = v.id;
          if (precio) precio.textContent = v.price;
          if (tachado) { tachado.textContent = v.compare || ''; tachado.hidden = !v.compare; }
          if (ahorro) { ahorro.textContent = v.ahorro || ''; ahorro.hidden = !v.ahorro; }
          if (boton) { boton.disabled = !v.available; boton.querySelector('span').textContent = v.available ? textoBoton : textoAgotado; }
          if (v.media) {
            var m = root.querySelector('[data-mt-mini][data-media="' + v.media + '"]');
            if (m) mostrar(m);
          }
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        });
      });
    });
  }

  function init() { initReveal(); initParallax(); initProducto(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', initReveal);
})();
